import { IStorageTransform } from './types';
import DefaultTransform from './defaultTransform';

export default abstract class STORAGE<T> {
  private key: string;

  private transform: IStorageTransform<T>;

  constructor(key: string, transform?: IStorageTransform<T>) {
    this.key = key;
    this.transform = transform || new DefaultTransform();
  }

  abstract get storage(): any;

  get(): T | null {
    const value = this.storage?.getItem(this.key);
    if (value === undefined || value === null || value === '') return null;
    return this.transform.toTargetType(value);
  }

  set(newValue: T) {
    this.storage?.setItem(this.key, this.transform.toString(newValue));
  }

  clean() {
    this.storage?.removeItem(this.key);
  }
}
